const MarkdownIt = require('markdown-it');

const announcementSanitizeOptions = Object.freeze({
  ADD_ATTR: Object.freeze(['rel', 'target']),
});

const markdown = new MarkdownIt({
  breaks: true,
  html: false,
});

const defaultLinkOpenRenderer =
  markdown.renderer.rules.link_open ||
  ((tokens, index, options, _env, self) => self.renderToken(tokens, index, options));

markdown.renderer.rules.link_open = (tokens, index, options, env, self) => {
  tokens[index].attrSet('rel', 'noreferrer');
  tokens[index].attrSet('target', '_blank');
  return defaultLinkOpenRenderer(tokens, index, options, env, self);
};

/**
 * Renders announcement markdown into HTML.
 * Supports the Markdown syntax provided by markdown-it, including links, images,
 * headings, emphasis, lists, tables, code blocks, and blockquotes.
 * @param {string} message - The announcement message in markdown format.
 * @returns {string} The rendered HTML string.
 */
const renderAnnouncementMarkdown = (message) =>
  markdown.render(String(message || ''))//;

module.exports = {
  announcementSanitizeOptions,
  renderAnnouncementMarkdown,
};
